import { useCreditCardSetupContext } from '@apps/registry/admin/components/CreditCardSetup/CreditCardSetUp.context';
import { useShippingAddressAndCurrencyDialogsContext } from '../components/ShippingAddressAndCurrencyDialogsProvider';
import { hasActiveStripeAccount } from '@shared/utils/payoutAccount';

export const useShouldShowConnectBankAccountButton = () => {
  const { registryShippingAddress } = useShippingAddressAndCurrencyDialogsContext();
  const { payoutAccountInfo } = useCreditCardSetupContext();

  // If account has active Stripe connection (onboarding/pending/readyToUse), don't show button (already connected)
  // Only show button for users with no account or rejected accounts (need to start/restart connection)
  if (payoutAccountInfo && hasActiveStripeAccount(payoutAccountInfo.status)) {
    return false;
  }

  // For NEW accounts, enforce US-only restriction
  if (!registryShippingAddress || registryShippingAddress.countryCode !== 'USA') {
    return false;
  }

  return true; // No account OR rejected account + valid US address = show button
};
